import React, { useEffect, useState } from "react";
import AWS from "aws-sdk";
import Modal from "react-modal";

const RomGallery = ({ romGallery }) => {
  const [signedUrls, setSignedUrls] = useState({});
  const [modalImage, setModalImage] = useState(null);
  const [modalIsOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchSignedUrls = async () => {
      const s3 = new AWS.S3({
        accessKeyId: "AKIAQEIP3MK7YSCRON7B",
        secretAccessKey: "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",
        region: "ap-southeast-2",
        signatureVersion: "v4",
      });

      const urls = {};
      for (const romItem of romGallery) {
        if (romItem.image) {
          const imageKey = romItem.image.split(".com/")[1];
          if (imageKey) {
            const params = {
              Bucket: "engivio-rom-uploads",
              Key: imageKey,
              Expires: 60, // URL expires in 60 seconds
            };
            urls[romItem.id] = await s3.getSignedUrlPromise(
              "getObject",
              params
            );
          }
        }
      }
      setSignedUrls(urls);
    };

    fetchSignedUrls();
  }, [romGallery]);

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    return new Date(dateString).toLocaleDateString("en-GB", options);
  };

  // Sort by id in descending order and get the latest 6 items
  const latestRomGallery = romGallery.sort((a, b) => b.id - a.id).slice(0, 6);

  const handleItemClick = (imageUrl) => {
    setModalImage(imageUrl);
    setIsOpen(true);
  };

  const closeModal = () => {
    setModalImage(null);
    setIsOpen(false);
  };

  return (
    <section className="rom-gallery-section">
      <h3 className="card-title">ROM Gallery</h3>
      <div className="rom-section-container">
        {latestRomGallery.length > 0 ? (
          latestRomGallery.map((romItem, index) => (
            <div className="item-rom" key={romItem.id}>
              <div
                className="item"
                onClick={() =>
                  handleItemClick(
                    signedUrls[romItem.id] || "../videoPlaceholder.jpg"
                  )
                }
              >
                <p className="angle">{romItem.rom_value}°</p>
                <p className="date">{formatDate(romItem.checkin_date)}</p>
                <i className="best-record" />
                <img
                  src={signedUrls[romItem.id] || "../videoPlaceholder.jpg"}
                  alt={`ROM ${index + 1}`}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="zero-state">
            <img src="../rom-zerostate.svg" width="70" alt="rom-zerostate" />
              <h4>No photos to show for now</h4>
              <p>
                <a href="/rom">Check your ROM</a> and see your progress!
              </p>
          </div>
        )}
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="ROM Modal"
        className="rom-modal"
      >
        <span className="close" onClick={closeModal}>
          &times;
        </span>
        <img className="modal-content" src={modalImage} alt="ROM Modal" />
      </Modal>
    </section>
  );
};

export default RomGallery;
